import Logo from '../logos/corona';

export default Logo;
